// @flow
import flatten from 'lodash/flatten';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import mapboxgl from 'mapbox-gl';

import type { ID_TYPE } from '../../types/common';
import * as routesActions from '../../actions/routes';
import * as selectors from '../../reducers/index';
import MapLine from '../MapLine';
import MapPoint from '../MapPoint';
import type { ROUTE_STOP_TYPE } from '../../types/routes';

type RouteDrawingType = {
  map: mapboxgl.Map,
  routePath?: Object,
  sourceName: string,
  layerId: ID_TYPE,
  stops: Array<ROUTE_STOP_TYPE>
};

const RouteDrawing = ({
  routePath,
  map,
  sourceName,
  layerId,
  stops = [],
}: RouteDrawingType) => (
  <Fragment>
    {
      routePath
        && (
          <MapLine
            id={layerId}
            map={map}
            path={routePath}
            sourceName={sourceName}
          />
        )
    }
    {
      stops.map(
        stop => stop
          && (
            <MapPoint
              id={stop.id}
              key={stop.id}
              sourceName={sourceName}
              map={map}
            />
          ),
      )
    }
  </Fragment>
);


export default connect(
  (state) => {
    const routeId = selectors.getSelectedRoute(state);
    const stops = selectors.getRouteStops(state, routeId);
    return {
      routePath: {
        type: 'LineString',
        coordinates: flatten(stops.map(stop => stop.path_to_next_stop)).map(
          ({ longitude, latitude }) => [longitude, latitude],
        ),
      },
      layerId: routeId,
      stops,
    };
  },
  dispatch => ({
    startFetchRoutePath: routeId => dispatch(routesActions.startFetchRoutePath((routeId))),
  }),
)(RouteDrawing);



// WEBPACK FOOTER //
// ./src/scripts/components/RouteDrawing/RouteDrawing.jsx